/**
 * BATANOVA paket fiyatlandırması (sepet).
 *
 * Paketler (1'li / 2'li / 3'lü set) aynı ürünün ayrı seçenekleridir. Müşteri sepette 1'li setin
 * adedini artırırsa Shopify bunu "1'li × adet" diye fiyatlar. Bu modül her sepet değişikliğinden
 * sonra toplam set sayısını en ucuz paket kombinasyonuna çevirir (ör. 1'li × 2 → 2'li × 1) ve
 * çekmeceyi Horizon'un kendi olayıyla yeniden çizdirir.
 *
 * Veri: layout'taki <script id="bt-paket-veri"> (seçenek kimliği, set adedi, fiyat).
 */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const KAYNAK = 'batanova-paket';
let calisiyor = false;

function veriOku() {
  const el = document.getElementById('bt-paket-veri');
  if (!el) return null;
  try {
    const v = JSON.parse(el.textContent);
    return Array.isArray(v) && v.length > 1 ? v.filter((p) => p.satista) : null;
  } catch (e) {
    return null;
  }
}

/** En ucuz kombinasyon: dp[n] = n set için en düşük toplam fiyat (eşitlikte daha az satır). */
function enUcuz(n, paketler) {
  const dp = Array(n + 1).fill(null);
  dp[0] = { fiyat: 0, satir: 0, dagilim: {} };
  for (let i = 1; i <= n; i++) {
    for (const p of paketler) {
      if (p.adet > i || !dp[i - p.adet]) continue;
      const onceki = dp[i - p.adet];
      const aday = {
        fiyat: onceki.fiyat + p.fiyat,
        satir: onceki.satir + (onceki.dagilim[p.id] ? 0 : 1),
        dagilim: { ...onceki.dagilim, [p.id]: (onceki.dagilim[p.id] || 0) + 1 },
      };
      const mevcut = dp[i];
      if (!mevcut || aday.fiyat < mevcut.fiyat || (aday.fiyat === mevcut.fiyat && aday.satir < mevcut.satir)) {
        dp[i] = aday;
      }
    }
  }
  return dp[n] ? dp[n].dagilim : null;
}

function bolumKimlikleri() {
  const s = new Set();
  document.querySelectorAll('cart-items-component').forEach((c) => {
    if (c.dataset.sectionId) s.add(c.dataset.sectionId);
  });
  if (document.getElementById('cart-drawer')) s.add('cart-drawer-section');
  return Array.from(s);
}

/**
 * @param {number|null} [hedefToplam] - null: mevcut set sayısını koru, yalnızca en ucuza çevir;
 *   sayı: sepetteki toplam set sayısını bu değere getir (set sayacı − / +).
 */
async function duzenle(hedefToplam = null) {
  if (calisiyor) return;
  const paketler = veriOku();
  if (!paketler) return;
  calisiyor = true;
  document.querySelectorAll('[data-bt-set-sayac]').forEach((s) => s.classList.add('is-yukleniyor'));
  try {
    const sepet = await (await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js')).json();

    // Yalnızca özelliksiz (properties / abonelik yok) paket satırlarını hesaba kat
    const satirlar = sepet.items.filter(
      (it) => paketler.some((p) => p.id === it.variant_id) && !it.selling_plan_allocation && (!it.properties || Object.keys(it.properties).length === 0)
    );
    if (!satirlar.length && hedefToplam === null) return;

    const mevcut = {};
    let toplamSet = 0;
    for (const it of satirlar) {
      const p = paketler.find((x) => x.id === it.variant_id);
      mevcut[p.id] = (mevcut[p.id] || 0) + it.quantity;
      toplamSet += it.quantity * p.adet;
    }

    if (hedefToplam !== null) toplamSet = Math.max(0, hedefToplam);
    const hedef = toplamSet === 0 ? {} : enUcuz(toplamSet, paketler);
    if (!hedef) return;

    const degisiklik = {};
    let fark = false;
    for (const p of paketler) {
      const h = hedef[p.id] || 0;
      if ((mevcut[p.id] || 0) !== h) fark = true;
      degisiklik[p.id] = h;
    }
    if (!fark) return;

    const bolumler = bolumKimlikleri();
    const yanit = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: degisiklik, sections: bolumler.join(','), sections_url: window.location.pathname }),
    });
    const ajax = await yanit.json();
    if (ajax.errors || ajax.status) return;

    // Horizon'a "dışarıdan sepet güncellendi" de: çekmece ve sepet sayacı yeniden çizilir
    const ertelenen = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'cart',
        lines: Object.entries(degisiklik).map(([id, quantity]) => ({ id: String(id), quantity })),
        promise: ertelenen.promise,
      })
    );
    ertelenen.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajax),
      detail: {
        sections: ajax.sections ?? undefined,
        items: ajax.items,
        itemCount: ajax.item_count,
        source: KAYNAK,
        didError: false,
      },
    });
  } catch (e) {
    console.warn('[batanova-paket] Sepet paketleri düzenlenemedi:', e);
  } finally {
    calisiyor = false;
    document.querySelectorAll('[data-bt-set-sayac]').forEach((s) => s.classList.remove('is-yukleniyor'));
  }
}

// Sepetteki set sayacı: + bir set ekler, − bir set çıkarır, çöp kutusu hepsini kaldırır
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('[data-bt-set]');
  if (!btn) return;
  const sayac = btn.closest('[data-bt-set-sayac]');
  if (!sayac || sayac.classList.contains('is-yukleniyor')) return;
  e.preventDefault();
  const mevcut = Number(sayac.dataset.toplam) || 0;
  const islem = btn.dataset.btSet;
  const hedef = islem === '0' ? 0 : mevcut + Number(islem);
  duzenle(Math.max(0, hedef));
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const p = /** @type {any} */ (event).promise;
  if (!p) return;
  p.then((sonuc) => {
    if (sonuc?.detail?.source === KAYNAK || sonuc?.detail?.didError) return;
    // Horizon'un kendi yeniden çizimi bitsin diye kısa bekle
    setTimeout(duzenle, 250);
  }).catch(() => {});
});

// Sayfa ilk açıldığında da sepet tutarlı olsun (ör. önceki oturumdan kalan 1'li × 2)
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(duzenle, 800));
else setTimeout(duzenle, 800);
